import { useEffect } from "react";
import { useAppDispatch } from "../hooks/reduxHooks";
import { parse } from "query-string";
import { actualizeExtLoginState } from "../redux/actions/authActions";
import { setDisplayContext, updateUtmParameters } from "../redux/actions/generalActions";
import { DISPLAYED_CONTEXTS } from "../constants";
import { enableHJIntegration } from "../interaction";
import Notification from "../components/notification";
import { isGuardianPartnerParam, markGuardianOrigin } from "../utils/guardianOrigin";

function Guard({ children }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const searchObject: any = parse(window.location.search);
  const { consentAuthKey: code, email, displayedContext } = searchObject;
  const utmParameters = Object.keys(searchObject).filter(k => k.startsWith("utm_"));

  const dispatch = useAppDispatch();

  useEffect(() => {
   if (isGuardianPartnerParam()) {
      markGuardianOrigin();
    }
    if (displayedContext) {
      dispatch(setDisplayContext(displayedContext));
    }
    if (displayedContext === DISPLAYED_CONTEXTS.hj) {
      enableHJIntegration();
    }
    if (displayedContext && email && code) {
      dispatch(actualizeExtLoginState({ email, code }));
    }
    if (Object.keys(utmParameters).length !== 0) {
      const utmObject = utmParameters.reduce((cur, key) => {
        return Object.assign(cur, { [key]: searchObject[key] });
      }, {});
      dispatch(updateUtmParameters(utmObject));
    }
  }, [displayedContext, code, email, dispatch]);

  return (
    <>
      {children}
      <Notification />
    </>
  );
}

export default Guard;
